import axios from './HTTP'

export default {
  getAll (userId, callback) {
    axios
      .get('/api/worksites.json', {
        params: {
          user_id: userId
        }
      })
      .then(response => ( callback(response.data) ))
  },

  getWorksite (id, callback, errorCallback) {
    axios
      .get(`/api/worksites/${ id }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

}
